export const environment = {
    production: true,
    publicApiUrl: '',
    authClientId: '4pm-public-api'
};
